<template>
  <div class="block">
    <el-button @click="saveAsExcel">测试</el-button>
  </div>
</template>

<script>
import ExcelJS from 'exceljs/dist/es5/exceljs.browser'
import { saveAs } from 'file-saver'

export default {
  data () {
    return {}
  },
  methods: {
    async saveAsExcel () {
      const wb = new ExcelJS.Workbook()
      const ws1 = wb.addWorksheet('交建第一页')
      const page1Row1 = ws1.addRow(['a', 'b', 'c'])
      ws1.addRow([' aa', 'bb', 'bb'])
      ws1.addRow(['  aaa', 'bbb', 'ccc'])
      console.log('page1Row1')
      console.log(page1Row1)
      page1Row1.font = { bold: true, color: { argb: '00489A' } }
      page1Row1.fill = { color: { argb: '000000' } }
      const ws2 = wb.addWorksheet('交建第二页')
      const page2Row1 = ws2.addRow(['a', 'b', 'c'])
      page2Row1.font = { bold: true, color: { argb: 'FFF000' } }
      const buf = await wb.xlsx.writeBuffer()
      saveAs(new Blob([buf]), 'abc.xlsx')
    }
  }
}
</script>
